<div class="max-w-7xl mx-auto px-0 sm:px-4 mt-4 sm:mt-8 pb-12 w-full">

  <div class="w-full flex justify-between mb-4">
    <app-btn-back routeTo="/groups" btnText="Back"></app-btn-back>
  </div>

  <div class="mb-4 border-0 w-full">
    <h1 class="text-2xl font-semibold text-blueGray-800 tracking-tight">Search Communities</h1>
  </div>

  <!-- Search Card Component -->
  <div class="bg-white p-4 rounded-xl border border-blueGray-200 shadow-sm flex-none space-y-3">
    <!-- Location Search with explicit Search Button -->
    <div class="flex flex-col items-start gap-2 w-full">
      <div class="flex flex-row gap-2 items-center w-full">
        <div class="relative flex flex-row gap-2 w-full">
          <div
            class="flex flex-row w-full items-center border-2 border-primary-200 focus-within:border-primary-500 focus-within:ring-1 focus-within:ring-primary-500 rounded-lg px-3 bg-gray-100 transition-all duration-150">
            <i class="fas fa-search text-primary-300 text-sm focus:ring-0"></i>
            <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearchLocation()"
              placeholder="Enter Search Term"
              class="bg-gray-100 border-none ring-0 w-full text-sm text-blueGray-700 placeholder-blueGray-400 focus:outline-none focus:ring-0 focus:ring-primary-500 focus:border-transparent" />
          </div>
        </div>
      </div>
      <!-- Filter Chips Row (No Icons, select/unselect color is enough) -->
      <div class="flex flex-wrap gap-2 pt-1">
        <button type="button" (click)="setFilter('all')"
          [class]="'text-xs px-4 py-2 rounded-full border outline-none focus:outline-none transition-all ' + 
                                       (selectedFilters.includes('all') ? 'bg-primary-500 text-white border-primary-500 shadow' : 'bg-gray-100 text-primary-500 border-transparent hover:bg-gray-200')">
          All
        </button>
        <button type="button" (click)="setFilter('church')"
          [class]="'text-xs px-4 py-2 rounded-full border outline-none focus:outline-none transition-all ' + 
                                       (selectedFilters.includes('church') ? 'bg-primary-500 text-white border-primary-500 shadow' : 'bg-gray-100 text-primary-500 border-transparent hover:bg-gray-200')">
          Churches
        </button>
        <button type="button" (click)="setFilter('school')"
          [class]="'text-xs px-4 py-2 rounded-full border outline-none focus:outline-none transition-all ' + 
                                       (selectedFilters.includes('school') ? 'bg-primary-500 text-white border-primary-500 shadow' : 'bg-gray-100 text-primary-500 border-transparent hover:bg-gray-200')">
          Sunday Schools
        </button>
        <button type="button" (click)="setFilter('user')"
          [class]="'text-xs px-4 py-2 rounded-full border outline-none focus:outline-none transition-all ' + 
                                       (selectedFilters.includes('user') ? 'bg-primary-500 text-white border-primary-500 shadow' : 'bg-gray-100 text-primary-500 border-transparent hover:bg-gray-200')">
          Users
        </button>
      </div>
      <!-- Checkbox Row -->
      <div class="flex flex-row items-center justify-between mt-1 w-full">
        <app-checkbox label="Search near me" [ngModel]="searchNearMe" class="text-xs"
          (ngModelChange)="onSearchNearMeChange($event)"></app-checkbox>
        <app-btn-action bgColor="bg-primary-500 hover:bg-primary-300 disabled:bg-gray-200 active:bg-primary-500"
          label="Search" icon="fa fa-search" (clicked)="onSearchLocation()"></app-btn-action>
      </div>
    </div>
  </div>

  @if (nearbyError) {
  <div class="bg-red-50 text-red-800 p-3.5 rounded-xl mt-3 flex items-center justify-between gap-3 flex-none text-sm border border-red-200">
    <div class="flex items-center gap-3">
      <i class="fas fa-circle-exclamation text-base text-red-600"></i>
      <span>{{nearbyError}}</span>
    </div>
    <button (click)="openLocationModal()" type="button"
      class="px-3.5 py-1.5 bg-red-600 hover:bg-red-700 text-white text-xs font-semibold rounded-lg shadow-sm flex items-center gap-1.5 flex-shrink-0 transition-colors">
      <i class="fas fa-location-crosshairs"></i> Enable Location
    </button>
  </div>
  }

  <!-- Split Map & Results view -->
  <div class="grid grid-cols-12 gap-4 my-4">
    <!-- Map (Left side card) -->
    <div
      [class]="'bg-white rounded-xl overflow-hidden border border-blueGray-200 shadow-sm relative transition-all duration-300 h-[350px] md:h-[600px] ' + (hasSearched ? 'col-span-full md:col-span-6' : 'col-span-full')">
      <google-map height="100%" width="100%" [options]="mapOptions" [center]="mapCenter">
        @if (userLocation) {
        <map-advanced-marker [position]="userLocation" [content]="userLocationMarkerContent" title="Your Current Location" />
        }
        @for (marker of markers; track marker.id) {
        <map-advanced-marker #mapMarker="mapAdvancedMarker" [position]="marker.position" [content]="marker.content" [title]="marker.title"
          (mapClick)="selectGroup(marker.item, mapMarker)" (mapMouseover)="selectGroup(marker.item, mapMarker)" />
        }
        <map-info-window>
          @if (infoWindowGroup) {
          <div class="max-w-[240px] text-xs">
            <div class="flex items-center gap-2 mb-2">
              <div class="flex-shrink-0">
                @if (infoWindowGroup.imageUrl) {
                <img [src]="infoWindowGroup.imageUrl"
                  class="h-8 w-8 rounded-full object-cover border border-blueGray-200" />
                } @else {
                <div
                  class="h-8 w-8 rounded-full bg-primary-100 text-primary-500 font-bold flex items-center justify-center text-[10px]">
                  {{infoWindowGroup.name | initials}}
                </div>
                }
              </div>
              <div class="min-w-0">
                <h4 class="font-bold text-blueGray-800 truncate">{{infoWindowGroup.name}}</h4>
                @if (infoWindowGroup.city) {
                <p class="text-[10px] text-blueGray-500 truncate">{{infoWindowGroup.city}}</p>
                }
              </div>
            </div>
            @if (infoWindowGroup.description) {
            <p class="text-[10px] text-blueGray-600 line-clamp-2 mb-2">{{infoWindowGroup.description}}</p>
            }
            <div class="flex items-center justify-between pt-1 border-t border-blueGray-100 mt-2">
              <span
                class="text-[9px] capitalize px-1.5 py-0.5 rounded-full bg-blueGray-100 text-blueGray-600 font-medium">
                {{infoWindowGroup.groupType}}
              </span>
              <button (click)="onClick(infoWindowGroup)"
                class="text-[10px] text-primary-500 hover:text-primary-700 font-bold flex items-center border-none outline-none rin-0 focus:outline-none focus:ring-0 gap-1">
                View <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
          }
        </map-info-window>
      </google-map>
    </div>

    <!-- Results (Right side card) -->
    @if (hasSearched) {
    <div
      class="w-full col-span-full md:col-span-6 flex flex-col bg-white rounded-xl border border-blueGray-200 shadow-sm overflow-hidden h-[450px] md:h-[600px]">
      <div class="p-4 bg-gray-100 border-b border-blueGray-200 flex justify-between items-center flex-none">
        <span class="font-bold text-blueGray-700 text-sm">Results ({{filteredResults.length}})</span>
        @if (selectedGroup) {
        <button (click)="selectedGroup = null" class="text-xs text-primary-500 hover:underline">Clear
          Selection</button>
        }
      </div>

      <div class="flex-1 overflow-y-auto bg-gray-100 p-3 space-y-3">
        @if (loadingNearby) {
        <div class="space-y-3 animate-pulse">
          <div class="h-20 bg-blueGray-100 rounded-xl"></div>
          <div class="h-20 bg-blueGray-100 rounded-xl"></div>
          <div class="h-20 bg-blueGray-100 rounded-xl"></div>
        </div>
        } @else {
        @for (item of filteredResults; track item.id) {
        <div [id]="'item-' + item.id" (click)="selectGroup(item)"
          [class]="'flex flex-col p-3.5 rounded-xl border cursor-pointer transition-all ' + 
                            (selectedGroup?.id === item.id ? 'bg-secondary-50 border-secondary-500 shadow-sm' : 'bg-white border-blueGray-100 hover:bg-blueGray-50')">
          <div class="flex items-center gap-3">
            <div class="flex-shrink-0">
              @if (item.imageUrl) {
              <img [src]="item.imageUrl" class="h-10 w-10 rounded-full object-cover border border-blueGray-200" />
              } @else {
              <div
                class="h-10 w-10 rounded-full bg-primary-100 text-primary-500 font-bold flex items-center justify-center text-xs">
                {{item.name | initials}}
              </div>
              }
            </div>
            <div class="min-w-0 flex-1">
              <h4 class="font-bold text-blueGray-800 text-xs truncate">{{item.name}}</h4>
              <p class="text-[10px] text-blueGray-500 truncate mt-0.5">{{item.city || 'Location unavailable'}}</p>
            </div>
          </div>

          @if (item.description) {
          <p class="text-[10px] text-blueGray-600 line-clamp-2 mt-2 leading-relaxed">
            {{item.description}}
          </p>
          }

          <div class="mt-3 flex items-center justify-between border-t border-blueGray-50 pt-2 text-[10px]">
            <span class="capitalize px-2 py-0.5 rounded-full bg-blueGray-100 text-blueGray-600 font-medium">
              {{item.groupType}}
            </span>
            <button (click)="$event.stopPropagation(); onClick(item)"
              class="text-primary-500 hover:text-primary-700 font-bold flex items-center focus:ring-0 outline-none border-none gap-1">
              View {{ item.groupType === 'user' ? 'Profile' : 'Community' }} <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
        } @empty {
        <!-- Empty state WhatsApp / Create community -->
        <div class="flex flex-col items-center justify-center text-center p-6 h-full">
          <div
            class="h-14 w-14 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center text-xl mb-4">
            <i class="fas fa-search-minus"></i>
          </div>
          <h3 class="font-bold text-blueGray-800 text-sm">No Results</h3>
          <p class="text-xs text-blueGray-500 max-w-xs mt-2 mb-6">
            We couldn't find any results matching your filters. Try a different query or distance!
          </p>
          <div class="flex flex-col w-full gap-2 px-2">
            <button (click)="router.navigate(['/groups/create'])"
              class="w-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white font-bold text-xs id-create uppercase rounded-lg py-2.5 shadow hover:shadow-lg">
              Create Community
            </button>
            <a [href]="whatsAppInviteLink" target="_blank"
              class="w-full bg-emerald-500 hover:bg-emerald-600 text-white font-bold text-xs uppercase rounded-lg py-2.5 shadow hover:shadow-lg flex items-center justify-center gap-2">
              <i class="fab fa-whatsapp"></i> Invite Friends
            </a>
          </div>
        </div>
        }
        }
      </div>
    </div>
    }
  </div>

  <!-- Community Detail Modal/Popup -->
  @if (activeDetailItem) {
  <div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div
      class="bg-white rounded-2xl border border-blueGray-100 shadow-2xl w-full max-w-lg overflow-hidden flex flex-col relative animate-fade-in">

      <!-- Header Actions row (Close left, Join/Share right) -->
      <div class="flex items-center justify-between p-4 border-b border-blueGray-100 bg-gray-50 flex-none">
        <button (click)="closePopup()"
          class="text-blueGray-400 hover:text-blueGray-600 transition-colors p-1.5 focus:outline-none">
          <i class="fas fa-times text-lg"></i>
        </button>

        <div class="flex items-center gap-2">
          <!-- Share WhatsApp button -->
          <a [href]="getShareLink(activeDetailItem)" target="_blank"
            class="px-3.5 py-1.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full text-xs font-semibold shadow-sm flex items-center gap-1.5 transition-colors">
            <i class="fab fa-whatsapp text-sm"></i> Share
          </a>

          <!-- Join button (only for groups: church or school) -->
          @if (activeDetailItem.groupType !== 'user') {
          <button [disabled]="joinedGroups.has(activeDetailItem.id)" (click)="joinGroup(activeDetailItem)"
            [class]="'px-3.5 py-1.5 rounded-full text-xs font-semibold shadow-sm flex items-center gap-1.5 transition-all ' + 
                               (joinedGroups.has(activeDetailItem.id) ? 'bg-green-50 text-green-700 border border-green-200 cursor-not-allowed' : 'bg-primary-500 hover:bg-primary-600 text-white')">
            <i class="fas" [class.fa-check]="joinedGroups.has(activeDetailItem.id)"
              [class.fa-user-plus]="!joinedGroups.has(activeDetailItem.id)"></i>
            {{ joinedGroups.has(activeDetailItem.id) ? 'Requested' : 'Join' }}
          </button>
          }
        </div>
      </div>

      <!-- Modal Body Content -->
      <div class="p-6 overflow-y-auto max-h-[70vh] flex flex-col items-center text-center">
        <!-- Avatar / Image -->
        <div class="mb-4">
          @if (activeDetailItem.imageUrl) {
          <img [src]="activeDetailItem.imageUrl"
            class="h-24 w-24 rounded-full object-cover border-2 border-primary-100 shadow-md" />
          } @else {
          <div
            class="h-24 w-24 rounded-full bg-primary-100 text-primary-600 font-bold flex items-center justify-center text-3xl shadow-inner">
            {{activeDetailItem.name | initials}}
          </div>
          }
        </div>

        <!-- Name & Location -->
        <h2 class="text-xl font-bold text-blueGray-900 leading-snug">{{activeDetailItem.name}}</h2>
        @if (activeDetailItem.city) {
        <p class="text-xs text-blueGray-500 mt-1 flex items-center gap-1">
          <i class="fas fa-location-dot text-primary-400"></i> {{activeDetailItem.city}}
        </p>
        }

        <!-- Type Badge -->
        <span
          class="capitalize px-3 py-0.5 rounded-full bg-blueGray-100 text-blueGray-600 font-semibold text-[10px] tracking-wider mt-3">
          {{activeDetailItem.groupType}}
        </span>

        <!-- Separator -->
        <div class="w-full border-t border-blueGray-100 my-5"></div>

        <!-- Description -->
        <div class="w-full text-left space-y-4 text-xs">
          <div>
            <h4 class="font-bold text-blueGray-700 mb-1 uppercase tracking-wider text-[10px]">Description</h4>
            <p class="text-blueGray-600 leading-relaxed whitespace-pre-line">
              {{activeDetailItem.description || 'No description available for this community.'}}
            </p>
          </div>

          @if (activeDetailItem.email) {
          <div>
            <h4 class="font-bold text-blueGray-700 mb-1 uppercase tracking-wider text-[10px]">Contact Email</h4>
            <a [href]="'mailto:' + activeDetailItem.email" class="text-primary-500 hover:underline">
              {{activeDetailItem.email}}
            </a>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Enable Location Modal -->
  @if (showLocationModal) {
  <div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
    <div class="bg-white rounded-2xl border border-blueGray-100 shadow-2xl w-full max-w-md overflow-hidden flex flex-col relative">

      <!-- Header -->
      <div class="flex items-center justify-between p-4 border-b border-blueGray-100 bg-gray-50 flex-none">
        <div class="flex items-center gap-2.5">
          <div class="h-8 w-8 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center font-bold text-sm">
            <i class="fas fa-location-dot"></i>
          </div>
          <h3 class="font-bold text-blueGray-800 text-base">Enable Location</h3>
        </div>
        <button (click)="closeLocationModal()" type="button" class="text-blueGray-400 hover:text-blueGray-600 transition-colors p-1.5 focus:outline-none">
          <i class="fas fa-times text-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="p-6 flex flex-col items-center text-center space-y-4">
        <div class="h-16 w-16 rounded-full bg-primary-50 text-primary-500 flex items-center justify-center text-2xl shadow-sm border border-primary-100">
          @if (locationPermissionDenied) {
            <i class="fas fa-location-slash text-amber-500"></i>
          } @else {
            <i class="fas fa-location-crosshairs text-primary-500"></i>
          }
        </div>

        <div>
          <h4 class="text-lg font-bold text-blueGray-800">
            {{ locationPermissionDenied ? 'Location Access Blocked' : 'Search Communities Near You' }}
          </h4>
          <p class="text-xs text-blueGray-600 mt-2 leading-relaxed">
            @if (locationPermissionDenied) {
              Location access is blocked in your browser settings. To search for communities nearby, please allow location permissions.
            } @else {
              Enable location permissions to automatically discover churches, Sunday schools, and members near your location.
            }
          </p>
        </div>

        @if (locationPermissionDenied) {
          <!-- Browser Instructions Callout -->
          <div class="w-full bg-amber-50 border border-amber-200 rounded-xl p-3.5 text-left text-xs space-y-2">
            <div class="flex items-center gap-2 font-semibold text-amber-900">
              <i class="fas fa-shield-halved text-amber-600 text-sm"></i>
              <span>How to enable in your browser:</span>
            </div>
            <ol class="list-decimal list-inside text-amber-800 space-y-1 pl-1 text-[11px] leading-relaxed">
              <li>Click the <strong>Lock 🔒 or Tune 🎛️</strong> icon in your browser address bar.</li>
              <li>Find <strong>Location</strong> permissions.</li>
              <li>Change the setting to <strong>Allow</strong>.</li>
              <li>Click <strong>Try Again</strong> below.</li>
            </ol>
          </div>
        }

        <!-- Actions -->
        <div class="flex flex-col w-full gap-2.5 pt-2">
          <button (click)="enableLocationAndSearch()" type="button"
            class="w-full bg-primary-500 hover:bg-primary-600 text-white font-bold text-xs uppercase py-3 rounded-xl shadow-md transition-all flex items-center justify-center gap-2">
            <i class="fas fa-location-arrow"></i>
            {{ locationPermissionDenied ? 'Try Again' : 'Enable Location' }}
          </button>

          <button (click)="useApproximateLocation()" type="button"
            class="w-full bg-gray-100 hover:bg-gray-200 text-blueGray-700 font-semibold text-xs py-2.5 rounded-xl transition-all">
            Use Approximate (IP) Location
          </button>
        </div>
      </div>

    </div>
  </div>
  }
</div>